var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalShippingCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65909 17.6458C6.40152 18.3264 7.30303 18.6667 8.36364 18.6667C9.42424 18.6667 10.3258 18.3264 11.0682 17.6458C11.8106 16.9653 12.1818 16.1389 12.1818 15.1667H19.8182C19.8182 16.1389 20.1894 16.9653 20.9318 17.6458C21.6742 18.3264 22.5758 18.6667 23.6364 18.6667C24.697 18.6667 25.5985 18.3264 26.3409 17.6458C27.0833 16.9653 27.4545 16.1389 27.4545 15.1667H30V9.33333L26.1818 4.66667H22.3636V0H4.54545C3.84545 0 3.24621 0.228472 2.74773 0.685417C2.24924 1.14236 2 1.69167 2 2.33333V3.5H3.27273H4.5L4.54545 2.33333H19.8182V12.8333H11.1636C10.803 12.4833 10.3894 12.2014 9.92273 11.9875C9.45606 11.7736 8.93636 11.6667 8.36364 11.6667C7.79091 11.6667 7.27121 11.7736 6.80455 11.9875C6.33788 12.2014 5.92424 12.4833 5.56364 12.8333H4.54545H3.27273H2V15.1667H4.54545C4.54545 16.1389 4.91667 16.9653 5.65909 17.6458ZM9.27045 15.9979C9.02652 16.2215 8.72424 16.3333 8.36364 16.3333C8.00303 16.3333 7.70076 16.2215 7.45682 15.9979C7.21288 15.7743 7.09091 15.4972 7.09091 15.1667C7.09091 14.8361 7.21288 14.559 7.45682 14.3354C7.70076 14.1118 8.00303 14 8.36364 14C8.72424 14 9.02652 14.1118 9.27045 14.3354C9.51439 14.559 9.63636 14.8361 9.63636 15.1667C9.63636 15.4972 9.51439 15.7743 9.27045 15.9979ZM24.5432 15.9979C24.2992 16.2215 23.997 16.3333 23.6364 16.3333C23.2758 16.3333 22.9735 16.2215 22.7295 15.9979C22.4856 15.7743 22.3636 15.4972 22.3636 15.1667C22.3636 14.8361 22.4856 14.559 22.7295 14.3354C22.9735 14.1118 23.2758 14 23.6364 14C23.997 14 24.2992 14.1118 24.5432 14.3354C24.7871 14.559 24.9091 14.8361 24.9091 15.1667C24.9091 15.4972 24.7871 15.7743 24.5432 15.9979ZM27.7727 10.5H22.3636V7H24.9091L27.7727 10.5Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.25L5.6773 10.2499",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67773 5.25L1.00044 10.2499",
    stroke: "#A1A1A1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalShippingCrossIcon);
export default __webpack_public_path__ + "static/media/LocalShippingCrossIcon.45146aaccf6540435dbcd09d3478225b.svg";
export { ForwardRef as ReactComponent };